import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { getIntervalBarrierDate } from "shared";
import { RecentTransactionDisplay } from "@/components/RecentTransactionDisplay";
import { trpc } from "@/lib/trpcClient";

export const Route = createFileRoute("/_authed/_org/cards/$id/transactions")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { data: card } = useSuspenseQuery(
    trpc.card.get.queryOptions({ cardId: id }),
  );

  return (
    <div className="mx-auto w-full overflow-y-scroll px-7 pb-6">
      <RecentTransactionDisplay
        cardId={id}
        showHeader={false}
        periodStart={getIntervalBarrierDate(
          card.restriction.refreshInterval,
          "start",
          new Date(),
        )}
      />
    </div>
  );
}
